import type { SVGProps } from 'react'

export const IconGoogle = (props: SVGProps<SVGSVGElement>) => (
  <svg
    width="1em"
    height="1em"
    viewBox="0 0 256 262"
    xmlns="http://www.w3.org/2000/svg"
    preserveAspectRatio="xMidYMid"
    {...props}
  >
    <path
      d="M255.878 133.451c0-10.734-.871-18.567-2.756-26.69H130.55v48.448h71.947c-1.45 12.04-9.283 30.172-26.69 42.356l-.244 1.622 38.755 30.023 2.685.268c24.659-22.774 38.875-56.282 38.875-96.027"
      fill="#4285F4"
    />
    <path
      d="M130.55 261.1c35.248 0 64.839-11.605 86.453-31.622l-41.196-31.913c-11.024 7.688-25.82 13.055-45.257 13.055-34.523 0-63.824-22.773-74.269-54.25l-1.531.13-40.298 31.187-.527 1.465C35.393 231.798 79.49 261.1 130.55 261.1"
      fill="#34A853"
    />
    <path
      d="M56.281 156.37c-2.756-8.123-4.351-16.827-4.351-25.82 0-8.994 1.595-17.697 4.206-25.82l-.073-1.73L15.26 71.312l-1.335.635C5.077 89.644 0 109.517 0 130.55s5.077 40.905 13.925 58.602l42.356-32.782"
      fill="#FBBC05"
    />
    <path
      d="M130.55 50.479c24.514 0 41.05 10.589 50.479 19.438l36.844-35.974C195.245 12.91 165.798 0 130.55 0 79.49 0 35.393 29.301 13.925 71.947l42.211 32.783c10.59-31.477 39.891-54.251 74.414-54.251"
      fill="#EB4335"
    />
  </svg>
)

export const TwitterIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    role="img"
    viewBox="0 0 24 24"
    xmlns="http://www.w3.org/2000/svg"
    fill="currentColor"
    {...props}
  >
    <path d="M18.901 1.153h3.68l-8.04 9.19L24 22.846h-7.406l-5.8-7.584-6.638 7.584H.474l8.6-9.83L0 1.154h7.594l5.243 6.932ZM17.61 20.644h2.039L6.486 3.24H4.298Z" />
  </svg>
)

export function DiscordIcon(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg
      role="img"
      viewBox="0 0 24 24"
      xmlns="http://www.w3.org/2000/svg"
      fill="currentColor"
      {...props}
    >
      <path d="M20.317 4.3698a19.7913 19.7913 0 00-4.8851-1.5152.0741.0741 0 00-.0785.0371c-.211.3753-.4447.8648-.6083 1.2495-1.8447-.2762-3.68-.2762-5.4868 0-.1636-.3933-.4058-.8742-.6177-1.2495a.077.077 0 00-.0785-.037 19.7363 19.7363 0 00-4.8852 1.515.0699.0699 0 00-.0321.0277C.5334 9.0458-.319 13.5799.0992 18.0578a.0824.0824 0 00.0312.0561c2.0528 1.5076 4.0413 2.4228 5.9929 3.0294a.0777.0777 0 00.0842-.0276c.4616-.6304.8731-1.2952 1.226-1.9942a.076.076 0 00-.0416-.1057c-.6528-.2476-1.2743-.5495-1.8722-.8923a.077.077 0 01-.0076-.1277c.1258-.0943.2517-.1923.3718-.2914a.0743.0743 0 01.0776-.0105c3.9278 1.7933 8.18 1.7933 12.0614 0a.0739.0739 0 01.0785.0095c.1202.099.246.1981.3728.2924a.077.077 0 01-.0066.1276 12.2986 12.2986 0 01-1.873.8914.0766.0766 0 00-.0407.1067c.3604.698.7719 1.3628 1.225 1.9932a.076.076 0 00.0842.0286c1.961-.6067 3.9495-1.5219 6.0023-3.0294a.077.077 0 00.0313-.0552c.5004-5.177-.8382-9.6739-3.5485-13.6604a.061.061 0 00-.0312-.0286zM8.02 15.3312c-1.1825 0-2.1569-1.0857-2.1569-2.419 0-1.3332.9555-2.4189 2.157-2.4189 1.2108 0 2.1757 1.0952 2.1568 2.419 0 1.3332-.9555 2.4189-2.1569 2.4189zm7.9748 0c-1.1825 0-2.1569-1.0857-2.1569-2.419 0-1.3332.9554-2.4189 2.1569-2.4189 1.2108 0 2.1757 1.0952 2.1568 2.419 0 1.3332-.946 2.4189-2.1568 2.4189Z" />
    </svg>
  )
}

export function LinkedInIcon(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg
      role="img"
      viewBox="0 0 24 24"
      xmlns="http://www.w3.org/2000/svg"
      fill="currentColor"
      {...props}
    >
      <path d="M20.447 20.452h-3.554v-5.569c0-1.328-.027-3.037-1.852-3.037-1.853 0-2.136 1.445-2.136 2.939v5.667H9.351V9h3.414v1.561h.046c.477-.9 1.637-1.85 3.37-1.85 3.601 0 4.267 2.37 4.267 5.455v6.286zM5.337 7.433c-1.144 0-2.063-.926-2.063-2.065 0-1.138.92-2.063 2.063-2.063 1.14 0 2.064.925 2.064 2.063 0 1.139-.925 2.065-2.064 2.065zm1.782 13.019H3.555V9h3.564v11.452zM22.225 0H1.771C.792 0 0 .774 0 1.729v20.542C0 23.227.792 24 1.771 24h20.451C23.2 24 24 23.227 24 22.271V1.729C24 .774 23.2 0 22.222 0h.003z" />
    </svg>
  )
}

export function YouTubeIcon(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg
      role="img"
      viewBox="0 0 24 24"
      xmlns="http://www.w3.org/2000/svg"
      fill="currentColor"
      {...props}
    >
      <path d="M23.498 6.186a2.97 2.97 0 00-2.088-2.103C19.746 3.5 12 3.5 12 3.5s-7.746 0-9.41.583A2.97 2.97 0 00.502 6.186 31.079 31.079 0 000 12a31.08 31.08 0 00.502 5.814 2.97 2.97 0 002.088 2.103C4.254 20.5 12 20.5 12 20.5s7.746 0 9.41-.583a2.97 2.97 0 002.088-2.103A31.08 31.08 0 0024 12a31.079 31.079 0 00-.502-5.814zM9.75 15.5v-7l6 3.5-6 3.5z" />
    </svg>
  )
}

export function StopCircleIcon(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 24 24"
      fill="currentColor"
      {...props}
    >
      <path
        fillRule="evenodd"
        d="M2.25 12c0-5.385 4.365-9.75 9.75-9.75s9.75 4.365 9.75 9.75-4.365 9.75-9.75 9.75S2.25 17.385 2.25 12Zm6-2.438c0-.724.588-1.312 1.313-1.312h4.874c.725 0 1.313.588 1.313 1.313v4.874c0 .725-.588 1.313-1.313 1.313H9.564a1.312 1.312 0 0 1-1.313-1.313V9.564Z"
        clipRule="evenodd"
      />
    </svg>
  )
}

export function CrownIcon(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 12 12"
      fill="currentColor"
      {...props}
    >
      <path
        d="M1.74805 4.05004L1.77805 3.96604C1.85605 3.73204 2.06005 3.57604 2.31205 3.55804C2.54005 3.54004 2.76805 3.67804 2.87605 3.88804C2.98405 4.10404 2.95405 4.35604 2.79805 4.54204C2.78005 4.56004 2.76205 4.58404 2.73805 4.60804C3.18205 4.87804 3.62005 5.14804 4.05805 5.41804C4.22605 5.52004 4.39405 5.62204 4.55605 5.72404C4.65205 5.77804 4.72405 5.76604 4.77805 5.67004C5.28805 4.74004 5.79205 3.82204 6.30205 2.89204C6.08005 2.77804 5.94205 2.61004 5.92405 2.35804C5.91805 2.17804 5.97805 2.02804 6.10405 1.90804C6.35605 1.66804 6.76405 1.68604 6.98005 1.95604C7.23205 2.26204 7.14205 2.62804 6.74005 2.89804C6.87205 3.13804 7.00405 3.37804 7.13605 3.61204L8.23405 5.61004C8.31805 5.76604 8.37205 5.77804 8.52205 5.68804C9.08605 5.34004 9.65605 4.99204 10.22 4.65004C10.244 4.63204 10.274 4.62004 10.304 4.59604C10.184 4.47604 10.112 4.34404 10.106 4.18204C10.088 3.87604 10.298 3.61204 10.592 3.55804C10.898 3.50404 11.18 3.67804 11.276 3.97804C11.282 4.00204 11.294 4.02604 11.3 4.05004V4.26004C11.204 4.56604 11.006 4.74604 10.664 4.75204L10.628 4.86004C10.298 5.99404 9.96205 7.13404 9.63205 8.27404C9.59005 8.42404 9.53605 8.46004 9.38605 8.46004H3.66805C3.50605 8.46004 3.45805 8.42404 3.41605 8.27404L2.60605 5.50204C2.53405 5.25004 2.46205 5.00404 2.38405 4.75204C2.13205 4.75204 1.94005 4.65004 1.82005 4.43404C1.79005 4.38004 1.77205 4.32004 1.74805 4.26604V4.05004ZM6.50005 9.56404H9.17605C9.41605 9.56404 9.60205 9.70204 9.63205 9.88804C9.65605 10.074 9.50605 10.248 9.27805 10.29C9.24805 10.296 9.21205 10.296 9.17605 10.296H3.82405C3.62005 10.296 3.44605 10.194 3.39205 10.044C3.33205 9.89404 3.38605 9.72004 3.54805 9.63604C3.63205 9.59404 3.74605 9.56404 3.84205 9.56404H6.50005Z"
        fill="currentColor"
      />
    </svg>
  )
}

export function FeatureIcon(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <mask maskUnits="userSpaceOnUse" x="0" y="0" width="20" height="20">
        <rect width="20" height="20" fill="#D9D9D9" />
      </mask>
      <g mask="url(#mask0_1512_18597)">
        <rect
          x="1.69983"
          y="11.5469"
          width="7"
          height="7"
          rx="1"
          stroke="currentColor"
          strokeWidth="1.5"
        />
        <path
          d="M11 15C11 12.7909 12.7909 11 15 11V11C17.2091 11 19 12.7909 19 15V15C19 17.2091 17.2091 19 15 19V19C12.7909 19 11 17.2091 11 15V15Z"
          stroke="currentColor"
          strokeWidth="1.5"
        />
        <path
          d="M14.1588 2.3085C14.5525 1.69618 15.4475 1.69618 15.8412 2.3085L18.5095 6.45924C18.9373 7.12475 18.4595 8 17.6683 8H12.3317C11.5405 8 11.0627 7.12475 11.4905 6.45924L14.1588 2.3085Z"
          stroke="currentColor"
          strokeWidth="1.5"
        />
        <path
          d="M5.19983 2.54642C1.06273 0.241552 -1.69533 5.77319 5.19983 9C10.716 5.77319 9.79662 0.241559 5.19983 2.54642Z"
          stroke="currentColor"
          strokeWidth="1.5"
        />
      </g>
    </svg>
  )
}

export function DiscordLineIcon(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <mask
        id="mask0_1742_3990"
        maskUnits="userSpaceOnUse"
        x="0"
        y="0"
        width="20"
        height="20"
      >
        <rect
          x="0.0119048"
          y="0.0119048"
          width="19.9762"
          height="19.9762"
          fill="#D9D9D9"
          stroke="#111827"
          strokeWidth="0.0238095"
        />
      </mask>
      <g mask="url(#mask0_1742_3990)">
        <path
          d="M4.38086 5.97864C6.39276 4.70483 11.1785 3.40721 15.6071 5.99054"
          stroke="#111827"
          strokeWidth="1.2"
          strokeLinecap="round"
        />
        <path
          d="M3.83301 13.4519C7.19015 15.7733 12.5473 16.059 16.1782 13.44"
          stroke="#111827"
          strokeWidth="1.2"
          strokeLinecap="round"
        />
        <ellipse
          cx="7.23828"
          cy="10.8333"
          rx="1.5"
          ry="1.71429"
          stroke="#111827"
          strokeWidth="1.2"
          strokeLinecap="round"
        />
        <ellipse
          cx="12.7617"
          cy="10.8333"
          rx="1.5"
          ry="1.71429"
          stroke="#111827"
          strokeWidth="1.2"
          strokeLinecap="round"
        />
        <path
          d="M7.76216 4.28571L7.41692 3.16666C6.13121 3.29762 4.20264 3.84524 3.1193 4.72619C1.70264 6.95238 0.666985 10.869 0.666992 14.2976C1.75028 15.869 4.036 16.6667 5.67882 16.7738L6.89311 15.0714"
          stroke="#111827"
          strokeWidth="1.2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M12.2378 4.28571L12.5831 3.16666C13.8688 3.29762 15.7974 3.84524 16.8807 4.72619C18.2974 6.95238 19.333 10.869 19.333 14.2976C18.2497 15.869 15.964 16.6667 14.3212 16.7738L13.1069 15.0714"
          stroke="#111827"
          strokeWidth="1.2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
    </svg>
  )
}

export function Layout2Icon(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg
      width="28"
      height="28"
      viewBox="0 0 28 28"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <mask
        id="mask0_3336_7565"
        maskUnits="userSpaceOnUse"
        x="0"
        y="0"
        width="28"
        height="28"
      >
        <rect width="28" height="28" fill="#D9D9D9" />
      </mask>
      <g mask="url(#mask0_3336_7565)">
        <mask id="path-2-inside-1_3336_7565" fill="white">
          <rect x="4" y="6" width="20" height="16" rx="1" />
        </mask>
        <rect
          x="4"
          y="6"
          width="20"
          height="16"
          rx="1"
          stroke="#4B5563"
          strokeWidth="2.4"
          mask="url(#path-2-inside-1_3336_7565)"
        />
        <path
          d="M16.6 14C16.6 13.7791 16.7791 13.6 17 13.6H21C21.2209 13.6 21.4 13.7791 21.4 14V19C21.4 19.2209 21.2209 19.4 21 19.4H17C16.7791 19.4 16.6 19.2209 16.6 19V14Z"
          stroke="#4B5563"
          strokeWidth="1.2"
        />
        <path
          d="M16.6 11C16.6 11.2209 16.7791 11.4 17 11.4H21C21.2209 11.4 21.4 11.2209 21.4 11V9C21.4 8.77909 21.2209 8.6 21 8.6H17C16.7791 8.6 16.6 8.77909 16.6 9V11Z"
          stroke="#4B5563"
          strokeWidth="1.2"
        />
        <mask id="path-5-inside-2_3336_7565" fill="white">
          <rect x="6" y="15" width="9" height="5" rx="1" />
        </mask>
        <rect
          x="6"
          y="15"
          width="9"
          height="5"
          rx="1"
          stroke="#4B5563"
          strokeWidth="2.4"
          mask="url(#path-5-inside-2_3336_7565)"
        />
        <path
          d="M6.6 9C6.6 8.77909 6.77909 8.6 7 8.6H14C14.2209 8.6 14.4 8.77909 14.4 9V13C14.4 13.2209 14.2209 13.4 14 13.4H7C6.77909 13.4 6.6 13.2209 6.6 13V9Z"
          stroke="#4B5563"
          strokeWidth="1.2"
        />
      </g>
    </svg>
  )
}

export function TransferIcon(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg
      width="28"
      height="28"
      viewBox="0 0 28 28"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <mask
        id="mask0_3336_7571"
        maskUnits="userSpaceOnUse"
        x="0"
        y="0"
        width="28"
        height="28"
      >
        <rect width="28" height="28" fill="#D9D9D9" />
      </mask>
      <g mask="url(#mask0_3336_7571)">
        <path
          d="M1.6 10.5C1.6 10.2791 1.77909 10.1 2 10.1H9C9.22091 10.1 9.4 10.2791 9.4 10.5V17.5C9.4 17.7209 9.22091 17.9 9 17.9H2C1.77909 17.9 1.6 17.7209 1.6 17.5V10.5Z"
          stroke="#4B5563"
          strokeWidth="1.2"
        />
        <path
          d="M18.6 10.5C18.6 10.2791 18.7791 10.1 19 10.1H26C26.2209 10.1 26.4 10.2791 26.4 10.5V17.5C26.4 17.7209 26.2209 17.9 26 17.9H19C18.7791 17.9 18.6 17.7209 18.6 17.5V10.5Z"
          stroke="#4B5563"
          strokeWidth="1.2"
        />
        <path
          d="M10 14.5H17.5M17.5 14.5L14.4545 12M17.5 14.5L14.4545 17"
          stroke="#4B5563"
          strokeWidth="1.2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
    </svg>
  )
}

export function MarginIcon(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <mask maskUnits="userSpaceOnUse" x="0" y="0" width="16" height="16">
        <rect width="16" height="16" fill="#D9D9D9" />
      </mask>
      <g mask="url(#mask0_3882_8375)">
        <path d="M4 5H5.5V12H4V5Z" fill="#9FA4AE" />
        {/* <path d="M10.5 5H12V12H10.5V5Z" fill="#9FA4AE" /> */}
        <rect x="7.5" y="1" width="1" height="14" fill="#9FA4AE" />
      </g>
    </svg>
  )
}

export function PaddingIcon(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <mask maskUnits="userSpaceOnUse" x="0" y="0" width="16" height="16">
        <rect width="16" height="16" fill="#D9D9D9" />
      </mask>
      <g mask="url(#mask0_3882_8397)">
        <path d="M3 5H4.5V12H3V5Z" fill="#9FA4AE" />
        {/* <path d="M11.5 5H13V12H11.5V5Z" fill="#9FA4AE" /> */}
        <rect x="2" y="1" width="1" height="14" fill="#9FA4AE" />
        {/* <rect x="13" y="1" width="1" height="14" fill="#9FA4AE" /> */}
      </g>
    </svg>
  )
}

export function ImageIcon(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <mask
        id="mask0_4053_9679"
        style={{ maskType: 'alpha' }}
        maskUnits="userSpaceOnUse"
        x="0"
        y="0"
        width="20"
        height="20"
      >
        <rect width="20" height="20" fill="#D9D9D9" />
      </mask>
      <g mask="url(#mask0_4053_9679)">
        <rect
          x="3"
          y="4"
          width="14"
          height="12"
          rx="2"
          stroke="currentColor"
          strokeWidth="1.5"
        />
        <path
          d="M15.0892 14L5.20711 14C4.76165 14 4.53857 13.4614 4.85355 13.1464L7.69337 10.3066C7.86931 10.1307 8.14786 10.1109 8.34692 10.2602L9.61999 11.215C9.83294 11.3747 10.1337 11.3396 10.3041 11.1351L12.0617 9.02601C12.2785 8.76583 12.6858 8.79194 12.8676 9.07766L15.511 13.2316C15.7228 13.5644 15.4837 14 15.0892 14Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function DoubleTreeIcon(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M2.5 7.5H5.625M8.75 7.5H5.625M5.625 7.5V15"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
      />
      <path
        d="M8.75 5H13.125M17.5 5H13.125M13.125 5V15"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
      />
    </svg>
  )
}

export function EditIcon(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <mask
        id="mask0_12572_18952"
        style={{ maskType: 'alpha' }}
        maskUnits="userSpaceOnUse"
        x="0"
        y="0"
        width="16"
        height="16"
      >
        <rect
          x="0.5"
          y="0.5"
          width="15"
          height="15"
          fill="currentColor"
          stroke="currentColor"
        />
      </mask>
      <g mask="url(#mask0_12572_18952)">
        <path
          d="M1.76725 3.5C2.61544 3.27802 3.27802 2.61544 3.5 1.76725C3.72198 2.61544 4.38456 3.27802 5.23275 3.5C4.38456 3.72198 3.72198 4.38456 3.5 5.23275C3.27802 4.38456 2.61544 3.72198 1.76725 3.5Z"
          fill="currentColor"
          stroke="currentColor"
          strokeWidth="0.371212"
        />
        <path
          d="M14.5555 9.90918L14.2398 10.4344C13.7596 11.2331 13.7596 12.2315 14.2398 13.0302L14.5555 13.5554L14.0303 13.2396C13.2317 12.7595 12.2332 12.7595 11.4345 13.2396L10.9093 13.5554L11.2251 13.0302C11.7052 12.2315 11.7052 11.2331 11.2251 10.4344L10.9093 9.90918L11.4345 10.225C12.2332 10.7051 13.2317 10.7051 14.0303 10.225L14.5555 9.90918Z"
          fill="currentColor"
          stroke="currentColor"
          strokeWidth="0.371212"
        />
        <path
          d="M9.12843 9.97164L7.99991 11.3534C6.89991 12.7003 5.30993 13.555 3.57973 13.7296V13.7296C3.12936 13.775 2.72743 13.4468 2.68199 12.9964L2.56705 11.8571C2.46608 10.8564 2.76679 9.85655 3.40302 9.07754L8.41862 2.93629C9.29199 1.86691 10.8669 1.70801 11.9363 2.58138V2.58138C13.0057 3.45476 13.1646 5.02967 12.2912 6.09906L11.0261 7.64809"
          stroke="currentColor"
          strokeWidth="1.5"
          strokeLinecap="round"
        />
      </g>
    </svg>
  )
}

export function EditIconV2(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <mask
        id="mask0_3276_87746"
        style={{ maskType: 'alpha' }}
        maskUnits="userSpaceOnUse"
        x="0"
        y="0"
        width="16"
        height="16"
      >
        <rect width="16" height="16" fill="#D9D9D9" />
      </mask>
      <g mask="url(#mask0_3276_87746)">
        <path
          d="M2 14L14 14"
          stroke="currentColor"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M8.88067 1.68964L3.77754 6.79277C3.64735 6.92296 3.5611 7.09057 3.53083 7.27218L3.10042 9.85463C2.98762 10.5315 3.57439 11.1182 4.25121 11.0054L6.83367 10.575C7.01528 10.5447 7.18289 10.4585 7.31307 10.3283L12.4162 5.22518C13.3925 4.24887 13.3925 2.66595 12.4162 1.68964C11.4399 0.713331 9.85698 0.713331 8.88067 1.68964Z"
          stroke="currentColor"
          strokeWidth="1.5"
          strokeLinecap="round"
        />
      </g>
    </svg>
  )
}
export function ButtonIcon(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <rect
        x="1"
        y="5"
        width="18"
        height="10"
        rx="2"
        stroke="currentColor"
        strokeWidth="1.5"
      />
    </svg>
  )
}

export function ChatInput(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      {...props}
    >
      <mask
        id="mask0_3276_87735"
        style={{ maskType: 'alpha' }}
        maskUnits="userSpaceOnUse"
        x="0"
        y="0"
        width="16"
        height="16"
      >
        <rect width="16" height="16" fill="currentColor" />
      </mask>
      <g mask="url(#mask0_3276_87735)">
        <path
          d="M3.32705 1.69438C3.37194 1.51417 3.62806 1.51417 3.67295 1.69438C3.87328 2.4987 4.5013 3.12672 5.30562 3.32705C5.48583 3.37194 5.48583 3.62806 5.30562 3.67295C4.5013 3.87328 3.87328 4.5013 3.67295 5.30562C3.62806 5.48583 3.37194 5.48583 3.32705 5.30562C3.12672 4.5013 2.4987 3.87328 1.69438 3.67295C1.51417 3.62806 1.51417 3.37194 1.69438 3.32705C2.4987 3.12672 3.12672 2.4987 3.32705 1.69438Z"
          fill="currentColor"
        />
        <path
          d="M14.4599 9.75011C14.6257 9.65046 14.8143 9.83907 14.7146 10.0048L14.3988 10.5301C13.9541 11.2699 13.9541 12.1947 14.3988 12.9345L14.7146 13.4598C14.8143 13.6255 14.6257 13.8141 14.4599 13.7145L13.9347 13.3987C13.1949 12.954 12.27 12.954 11.5302 13.3987L11.0049 13.7145C10.8392 13.8141 10.6506 13.6255 10.7502 13.4598L11.066 12.9345C11.5108 12.1947 11.5108 11.2699 11.066 10.5301L10.7502 10.0048C10.6506 9.83907 10.8392 9.65046 11.0049 9.75011L11.5302 10.0659C12.27 10.5106 13.1949 10.5106 13.9347 10.0659L14.4599 9.75011Z"
          fill="currentColor"
        />
        <path
          d="M9.12843 9.97164L7.99991 11.3534C6.89991 12.7003 5.30993 13.555 3.57973 13.7296V13.7296C3.12936 13.775 2.72743 13.4468 2.68199 12.9964L2.56705 11.8571C2.46608 10.8564 2.76679 9.85655 3.40302 9.07754L8.41862 2.93629C9.29199 1.86691 10.8669 1.70801 11.9363 2.58138V2.58138C13.0057 3.45476 13.1646 5.02967 12.2912 6.09906L11.0261 7.64809"
          stroke="currentColor"
          strokeWidth="1.5"
          strokeLinecap="round"
        />
      </g>
    </svg>
  )
}

export function ChevronDown(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="12"
      height="12"
      viewBox="0 0 12 12"
      fill="none"
      {...props}
    >
      <mask
        id="mask0_3290_90627"
        style={{ maskType: 'alpha' }}
        maskUnits="userSpaceOnUse"
        x="0"
        y="0"
        width="12"
        height="12"
      >
        <rect width="12" height="12" fill="#D9D9D9" />
      </mask>
      <g mask="url(#mask0_3290_90627)">
        <path
          d="M6.35355 8.68746L9.38909 5.65193C9.70407 5.33695 9.48099 4.79837 9.03553 4.79837L2.96447 4.79838C2.51901 4.79838 2.29593 5.33695 2.61091 5.65193L5.64645 8.68746C5.84171 8.88272 6.15829 8.88272 6.35355 8.68746Z"
          fill="white"
        />
      </g>
    </svg>
  )
}

export function HumanHelp(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      {...props}
    >
      <g clip-path="url(#clip0_3441_12086)">
        <path
          d="M10.3854 7.54872C11.4547 6.7982 12.1571 5.55536 12.1571 4.15084C12.1571 1.86306 10.2961 0 8.00537 0C5.71709 0 3.85359 1.86062 3.85359 4.15084C3.85359 5.55538 4.55359 6.79819 5.62534 7.54872C4.6357 7.89866 3.72812 8.46819 2.96297 9.23078C1.61603 10.5774 0.875 12.368 0.875 14.2721C0.875 14.7137 0.875 15.054 0.877422 15.4232C0.879844 15.7418 1.13813 16 1.45673 16C1.7802 15.9976 2.03608 15.7369 2.03608 15.4184C2.03364 15.0516 2.03364 14.7137 2.03364 14.2745C2.03364 10.9828 4.71298 8.30166 8.00781 8.30166C9.1875 8.17969 9.53906 8.07031 10.3854 7.54872ZM5.01225 4.15081C5.01225 2.50014 6.35433 1.15834 8.00537 1.15834C9.65644 1.15834 10.9985 2.50013 10.9985 4.15081C10.9985 5.8015 9.65644 7.14331 8.00539 7.14331C6.35433 7.14331 5.01225 5.79909 5.01225 4.15081ZM7.20819 11.5182L8.41167 9.74292C8.58426 9.48831 8.9298 9.42042 9.18591 9.59077C9.43586 9.75702 9.50369 10.0944 9.33744 10.3444C9.33525 10.3477 9.33303 10.3509 9.33078 10.3542L8.06312 12.1727C8.04466 12.1992 8.03486 12.2308 8.03507 12.2631C8.03527 12.2954 8.04549 12.3268 8.0643 12.353L9.36814 14.173C9.54061 14.4138 9.48526 14.7488 9.24451 14.9213C9.23433 14.9285 9.22389 14.9355 9.21323 14.942C8.93926 15.1106 8.58112 15.0336 8.40062 14.7674L7.20817 13.0083L6.82198 12.4386C6.7869 12.3869 6.76815 12.3258 6.76815 12.2633C6.76815 12.2008 6.7869 12.1397 6.82198 12.0879L7.20817 11.5183L7.20819 11.5182ZM14.6847 11.5182L13.4812 9.74292C13.3087 9.48831 12.9631 9.42042 12.707 9.59077C12.4571 9.75702 12.3892 10.0944 12.5555 10.3444C12.5577 10.3477 12.5599 10.3509 12.5622 10.3542L13.8298 12.1727C13.8482 12.1992 13.8581 12.2308 13.8578 12.2631C13.8576 12.2954 13.8474 12.3268 13.8286 12.353L12.5248 14.173C12.3523 14.4138 12.4076 14.7488 12.6484 14.9213C12.6586 14.9285 12.669 14.9355 12.6797 14.942C12.9537 15.1106 13.3118 15.0336 13.4923 14.7674L14.6847 13.0083L15.0709 12.4386C15.106 12.3869 15.1248 12.3258 15.1248 12.2633C15.1248 12.2008 15.106 12.1397 15.0709 12.0879L14.6847 11.5183L14.6847 11.5182ZM12.317 8.98694L10.9388 15.4777C10.8646 15.8274 10.5222 16.0518 10.1719 15.9805C9.82772 15.9104 9.60556 15.5745 9.67567 15.2304C9.67633 15.2272 9.677 15.224 9.6777 15.2208L11.1082 8.71258C11.1809 8.38172 11.5081 8.17245 11.8389 8.24517L11.843 8.24609C12.177 8.32191 12.3882 8.65194 12.317 8.98694Z"
          fill="currentColor"
        />
      </g>
      <defs>
        <clipPath id="clip0_3441_12086">
          <rect width="16" height="16" fill="currentColor" />
        </clipPath>
      </defs>
    </svg>
  )
}

export function IconBasicHosting(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="12"
      height="12"
      viewBox="0 0 12 12"
      fill="none"
      {...props}
    >
      <title>Free</title>
      <mask
        id="mask0_4708_5137"
        style={{ maskType: 'alpha' }}
        maskUnits="userSpaceOnUse"
        x="0"
        y="0"
        width="12"
        height="12"
      >
        <rect width="12" height="12" fill="#D9D9D9" />
      </mask>
      <g mask="url(#mask0_4708_5137)">
        <mask
          id="mask1_4708_5137"
          style={{ maskType: 'alpha' }}
          maskUnits="userSpaceOnUse"
          x="1"
          y="0"
          width="10"
          height="12"
        >
          <path
            d="M1.29756 5.48622L5.40062 0.699315C5.7157 0.331727 6.28437 0.331727 6.59945 0.699315L10.7025 5.48622C10.9559 5.78187 10.9559 6.21813 10.7025 6.51378L6.59945 11.3007C6.28437 11.6683 5.7157 11.6683 5.40062 11.3007L1.29756 6.51378C1.04415 6.21813 1.04415 5.78187 1.29756 5.48622Z"
            fill="#D9D9D9"
          />
        </mask>
        <g mask="url(#mask1_4708_5137)">
          <path
            d="M0.857178 6L6.00003 0L11.1429 6L6.00003 12L0.857178 6Z"
            fill="#D9D9D9"
          />
          <path
            d="M8.57132 5.82857H3.42847L5.9999 0L8.57132 5.82857Z"
            fill="url(#paint0_linear_4708_5137)"
          />
          <path
            d="M3.42868 5.82857H8.57153L6.0001 12L3.42868 5.82857Z"
            fill="url(#paint1_linear_4708_5137)"
          />
          <path
            d="M3.42861 5.82857L0.857178 6L6.00003 0L3.42861 5.82857Z"
            fill="url(#paint2_linear_4708_5137)"
          />
          <path
            d="M3.42861 5.82812L0.857178 5.99955L6.00003 11.9996L3.42861 5.82812Z"
            fill="url(#paint3_linear_4708_5137)"
          />
          <path
            d="M8.57139 5.82857L11.1428 6L5.99997 0L8.57139 5.82857Z"
            fill="url(#paint4_linear_4708_5137)"
          />
          <path
            d="M8.57139 5.82812L11.1428 5.99955L5.99997 11.9996L8.57139 5.82812Z"
            fill="url(#paint5_linear_4708_5137)"
          />
        </g>
      </g>
      <defs>
        <linearGradient
          id="paint0_linear_4708_5137"
          x1="5.9999"
          y1="0.578571"
          x2="6.06619"
          y2="5.99919"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#1BD1FA" />
          <stop offset="1" stopColor="#2BB1FC" />
        </linearGradient>
        <linearGradient
          id="paint1_linear_4708_5137"
          x1="6.0001"
          y1="11.4214"
          x2="5.93381"
          y2="6.00081"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#46C4FD" />
          <stop offset="1" stopColor="#02E2FB" />
        </linearGradient>
        <linearGradient
          id="paint2_linear_4708_5137"
          x1="5.50718"
          y1="0.407143"
          x2="2.31432"
          y2="6"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#60CFFC" />
          <stop offset="1" stopColor="#55E3FE" />
        </linearGradient>
        <linearGradient
          id="paint3_linear_4708_5137"
          x1="3.81432"
          y1="8.48527"
          x2="5.18575"
          y2="11.5281"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#2AAFFD" />
          <stop offset="1" stopColor="#06DCFC" />
        </linearGradient>
        <linearGradient
          id="paint4_linear_4708_5137"
          x1="6.68568"
          y1="0.578571"
          x2="9.89997"
          y2="5.87143"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#1FD8FE" />
          <stop offset="1" stopColor="#54CDFF" />
        </linearGradient>
        <linearGradient
          id="paint5_linear_4708_5137"
          x1="8.57139"
          y1="5.82812"
          x2="7.11425"
          y2="11.5924"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#BBFFFF" />
          <stop offset="1" stopColor="#9DE9FC" />
        </linearGradient>
      </defs>
    </svg>
  )
}

export function LeftArrowIcon(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg
      viewBox="0 0 18 18"
      fill="currentColor"
      width="18"
      height="18"
      {...props}
    >
      <path d="M7.85710678,6.14212718 C8.05049539,6.33551579 8.05074179,6.64898459 7.85765744,6.84267698 L5.70710678,9 L14,9 L14,10 L5.70710678,10 L7.85728896,12.1524212 C8.05051745,12.3458509 8.0504359,12.6592741 7.85710678,12.8526033 C7.66371856,13.0459915 7.35025004,13.0462368 7.15655932,12.8531516 L3.79289322,9.5 L7.1568079,6.14182805 C7.35032102,5.94864528 7.66375877,5.94877917 7.85710678,6.14212718 Z"></path>
    </svg>
  )
}

export function IconPremiumHosting(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="12"
      height="12"
      viewBox="0 0 12 12"
      fill="none"
      {...props}
    >
      <title>Pro</title>
      <mask
        id="mask0_4708_5323"
        style={{ maskType: 'alpha' }}
        maskUnits="userSpaceOnUse"
        x="0"
        y="0"
        width="12"
        height="11"
      >
        <path
          d="M5.30145 1.04604C5.63401 0.548042 6.36599 0.548041 6.69855 1.04604L7.91558 2.86846C8.02673 3.03491 8.19367 3.1562 8.38633 3.21048L10.4956 3.80478C11.072 3.96718 11.2982 4.66333 10.9274 5.13351L9.57022 6.85412C9.44626 7.01127 9.3825 7.20753 9.39041 7.40752L9.47701 9.59724C9.50067 10.1956 8.90849 10.6258 8.34672 10.4184L6.29094 9.65942C6.10318 9.59009 5.89683 9.59009 5.70906 9.65942L3.65328 10.4184C3.09151 10.6258 2.49933 10.1956 2.52299 9.59724L2.60959 7.40752C2.6175 7.20753 2.55374 7.01127 2.42978 6.85412L1.07264 5.13351C0.701784 4.66333 0.927975 3.96718 1.50437 3.80478L3.61367 3.21048C3.80633 3.1562 3.97327 3.03491 4.08442 2.86846L5.30145 1.04604Z"
          fill="#D9D9D9"
        />
      </mask>
      <g mask="url(#mask0_4708_5323)">
        <path
          d="M-0.47998 -2.75977H6.00002V6.00023L3.48002 2.40023L-0.47998 -2.75977Z"
          fill="url(#paint0_linear_4708_5323)"
        />
        <path
          d="M-0.47998 -2.75977V3.96023L6.00002 6.00023L3.48002 2.40023L-0.47998 -2.75977Z"
          fill="url(#paint1_linear_4708_5323)"
        />
        <path
          d="M-0.0599805 8.04094L-0.47998 3.96094L6.00002 6.00094L-0.0599805 8.04094Z"
          fill="url(#paint2_linear_4708_5323)"
        />
        <path
          d="M-0.0600586 8.04L2.21994 11.34L5.99994 6L-0.0600586 8.04Z"
          fill="url(#paint3_linear_4708_5323)"
        />
        <path
          d="M5.99997 11.34H2.21997L5.99997 6V11.34Z"
          fill="url(#paint4_linear_4708_5323)"
        />
        <path
          d="M12.48 -2.75977V3.96023L5.99998 6.00023L8.51998 2.40023L12.48 -2.75977Z"
          fill="url(#paint5_linear_4708_5323)"
        />
        <path
          d="M12.06 8.04094L12.48 3.96094L5.99998 6.00094L12.06 8.04094Z"
          fill="url(#paint6_linear_4708_5323)"
        />
        <path
          d="M12.0601 8.04L9.78006 11.34L6.00006 6L12.0601 8.04Z"
          fill="url(#paint7_linear_4708_5323)"
        />
        <path
          d="M6.00003 11.34H9.78003L6.00003 6V11.34Z"
          fill="url(#paint8_linear_4708_5323)"
        />
        <path
          d="M12.48 -2.75977H5.99998V6.00023L8.51998 2.40023L12.48 -2.75977Z"
          fill="url(#paint9_linear_4708_5323)"
        />
      </g>
      <defs>
        <linearGradient
          id="paint0_linear_4708_5323"
          x1="6.00002"
          y1="0.360235"
          x2="5.40002"
          y2="5.16023"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#EBC5F2" />
          <stop offset="1" stopColor="#B26FFF" />
        </linearGradient>
        <linearGradient
          id="paint1_linear_4708_5323"
          x1="6.00002"
          y1="6.00023"
          x2="1.02002"
          y2="3.96023"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#C37FFF" />
          <stop offset="0.779931" stopColor="#BFC6FD" />
          <stop offset="1" stopColor="#C9F4F6" />
        </linearGradient>
        <linearGradient
          id="paint2_linear_4708_5323"
          x1="2.94002"
          y1="5.10094"
          x2="2.76002"
          y2="6.96094"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#C9ACFE" />
          <stop offset="1" stopColor="#95AFFA" />
        </linearGradient>
        <linearGradient
          id="paint3_linear_4708_5323"
          x1="5.69994"
          y1="6"
          x2="2.99994"
          y2="9.48"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#7B74FD" />
          <stop offset="0.325" stopColor="#958EFE" />
          <stop offset="1" stopColor="#BDB8FD" />
        </linearGradient>
        <linearGradient
          id="paint4_linear_4708_5323"
          x1="5.69997"
          y1="7.68"
          x2="2.93997"
          y2="10.62"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#899EFE" />
          <stop offset="0.325" stopColor="#8CA9FD" />
          <stop offset="1" stopColor="#C5B7FE" />
        </linearGradient>
        <linearGradient
          id="paint5_linear_4708_5323"
          x1="5.99998"
          y1="6.00023"
          x2="10.98"
          y2="3.96023"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#EDA4FC" />
          <stop offset="0.586342" stopColor="#F8CAFF" />
          <stop offset="0.74081" stopColor="#F1DCFF" />
          <stop offset="1" stopColor="#C5A1F9" />
        </linearGradient>
        <linearGradient
          id="paint6_linear_4708_5323"
          x1="7.37998"
          y1="6.00094"
          x2="9.89998"
          y2="5.28094"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#C87FFE" />
          <stop offset="1" stopColor="#9985FB" />
        </linearGradient>
        <linearGradient
          id="paint7_linear_4708_5323"
          x1="6.30006"
          y1="6"
          x2="9.00006"
          y2="9.48"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#BD8FFD" />
          <stop offset="0.325" stopColor="#BF95FE" />
          <stop offset="1" stopColor="#BAE4FA" />
        </linearGradient>
        <linearGradient
          id="paint8_linear_4708_5323"
          x1="6.30003"
          y1="7.68"
          x2="9.06003"
          y2="10.62"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#917AF9" />
          <stop offset="0.325" stopColor="#8F88FC" />
          <stop offset="1" stopColor="#8CC9F4" />
        </linearGradient>
        <linearGradient
          id="paint9_linear_4708_5323"
          x1="5.99998"
          y1="0.360234"
          x2="6.83998"
          y2="4.74023"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#FAE6FF" />
          <stop offset="1" stopColor="#E7CAFF" />
        </linearGradient>
      </defs>
    </svg>
  )
}

export function AppMarketSearchIcon(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg
      viewBox="0 0 18 18"
      fill="currentColor"
      width="18px"
      height="18px"
      {...props}
    >
      <path d="M14.8539503,14.1467096 C15.0478453,14.3412138 15.0475893,14.6560006 14.8533783,14.8501892 C14.6592498,15.0442953 14.3445263,15.0442862 14.1504091,14.8501689 L12.020126,12.7261364 C11.066294,13.5214883 9.8390282,14 8.5,14 C5.46243388,14 3,11.5375661 3,8.5 C3,5.46243388 5.46243388,3 8.5,3 C11.5375661,3 14,5.46243388 14,8.5 C14,9.83874333 13.5216919,11.0657718 12.726644,12.0195172 L14.8539503,14.1467096 Z M8.5,13 C10.9852814,13 13,10.9852814 13,8.5 C13,6.01471863 10.9852814,4 8.5,4 C6.01471863,4 4,6.01471863 4,8.5 C4,10.9852814 6.01471863,13 8.5,13 Z"></path>
    </svg>
  )
}

export function AdminClose(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg
      width="28"
      height="28"
      viewBox="0 0 28 28"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <g id="Group 14">
        <mask
          id="mask0_58_11492"
          style={{ maskType: 'alpha' }}
          maskUnits="userSpaceOnUse"
          x="0"
          y="0"
          width="28"
          height="28"
        >
          <rect id="Rectangle 291" width="28" height="28" fill="#D9D9D9" />
        </mask>
        <g mask="url(#mask0_58_11492)">
          <path
            id="Union"
            d="M22.9086 5.08436C23.4552 5.6311 23.4546 6.51742 22.9079 7.06412L15.9791 13.9929L22.91 20.9238C23.4567 21.4705 23.4573 22.3568 22.9107 22.9036C22.3639 23.4503 21.4769 23.4503 20.9302 22.9036L13.9993 15.9727L7.06911 22.9029C6.52241 23.4496 5.63609 23.4502 5.08935 22.9036C4.54262 22.3569 4.54262 21.4699 5.08935 20.9231L12.0195 13.9929L5.09142 7.06481C4.54469 6.51808 4.54469 5.63109 5.09142 5.08436C5.63816 4.53773 6.52448 4.53835 7.07118 5.08505L13.9993 12.0132L20.9281 5.08436C21.4749 4.53763 22.3618 4.53763 22.9086 5.08436Z"
            fill="white"
            fillOpacity="0.6"
          />
        </g>
      </g>
    </svg>
  )
}

export const AdminExport = (props: React.SVGProps<SVGSVGElement>) => {
  return (
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <g id="Group 2085664838">
        <mask
          id="mask0_58_11519"
          style={{ maskType: 'alpha' }}
          maskUnits="userSpaceOnUse"
          x="0"
          y="0"
          width="16"
          height="16"
        >
          <path
            id="Rectangle 34647877"
            d="M0 0H16V16H0V0Z"
            fill="currentColor"
          />
        </mask>
        <g mask="url(#mask0_58_11519)">
          <path
            id="Rectangle 34647878"
            d="M14 9.5V12C14 13.1046 13.1046 14 12 14H4C2.89543 14 2 13.1046 2 12V4C2 2.89543 2.89543 2 4 2H6.5"
            stroke="currentColor"
            strokeWidth="1.5"
            strokeLinecap="round"
          />
          <path
            id="Vector 2227"
            d="M7.31666 8.68385L13.9987 2.0015M13.9987 2.0015L9.49869 2.0015M13.9987 2.0015L13.9987 6.50128"
            stroke="currentColor"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </g>
      </g>
    </svg>
  )
}

export const IconApple = (props: React.SVGProps<SVGSVGElement>) => (
  <svg
    viewBox="0 0 24 24"
    role="img"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      fill="#000"
      d="M12.152 6.896c-.948 0-2.415-1.078-3.96-1.04-2.04.027-3.91 1.183-4.961 3.014-2.117 3.675-.546 9.103 1.519 12.09 1.013 1.454 2.208 3.09 3.792 3.039 1.52-.065 2.09-.987 3.935-.987 1.831 0 2.35.987 3.96.948 1.637-.026 2.676-1.48 3.676-2.948 1.156-1.688 1.636-3.325 1.662-3.415-.039-.013-3.182-1.221-3.22-4.857-.026-3.04 2.48-4.494 2.597-4.559-1.429-2.09-3.623-2.324-4.39-2.376-2-.156-3.675 1.09-4.61 1.09zM15.53 3.83c.843-1.012 1.4-2.427 1.245-3.83-1.207.052-2.662.805-3.532 1.818-.78.896-1.454 2.338-1.273 3.714 1.338.104 2.715-.688 3.559-1.701"
    />
  </svg>
)
